var utils = function () {
  var cachedIsMobile = null;
  var clearCachedIsMobile = function clearCachedIsMobile() {
    cachedIsMobile = null;
  };
  return {
    get width() {
      return window.innerWidth;
    },
    get height() {
      return window.innerHeight;
    },
    get scrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop;
    },
    get isMobile() {
      if (cachedIsMobile === null) cachedIsMobile = window.matchMedia("screen and (max-width: 48em)").matches;
      return cachedIsMobile;
    },
    clearCachedIsMobile: clearCachedIsMobile
  };
}();
export { utils };